module.exports = __webpack_public_path__ + "static/media/icon-square-invited.6efb289f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-square-invited.svg
// module id = 740
// module chunks = 0